import { AccountContextContext } from '@/components/AccountContext';
import { useContext } from 'react';

export const useAccount = () => {
  const account = useContext(AccountContextContext);
  if (!account) {
    throw new Error('Trying to access account outside of the <AcountContext>');
  }
  return account;
};
